/** The order fields that carry its customer total, as the order list and detail APIs send them. */
export interface OrderTotalFields {
  display_total?: string | number | null;
  total?: string | number | null;
}

/**
 * An order's customer total, the one figure the order header shows: the API's display_total (after the mill
 * invoice, what the customer is billed for the shipped quantity, plus extra costs), else the ordered total.
 */
export function orderCustomerTotal(
  order: OrderTotalFields | null | undefined
): string | number | undefined {
  return order?.display_total ?? order?.total ?? undefined;
}
